import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../utils/LocalStorageHandler.js';
import fetchWithCache from "../../utils/ApiCaching";
import api from "../../config/api";
import { getLocationId } from '../../utils/SessionDataHandler.js';

const state = {
    hideConfigButton: false,
    isPinned: true,
    isSidenavCollapsed: false,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    color: "success",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    navbarFixed:
        "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    menuData: {},
    mainmenuData: {},
    dashboardData: {},
    dashboardTableCards: [],
    volunteerModules: [],
    permissionData: {},
    sessionData: JSON.parse(localStorage.getItem("sessionData")) || {}, // load from storage
    logoutResponse: {},
    lastActiveSideNavRoute: getLocalStorage("lastActiveSideNavRoute") || null, // Track the last active sidebar route
    sidebarRoutes: null, // Routes configuration for sidebar/navbar visibility
}
const mutations = {
    toggleConfigurator(state) {
        state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
        const sidenav_show = document.querySelector(".g-sidenav-show");

        if (sidenav_show.classList.contains("g-sidenav-pinned")) {
            sidenav_show.classList.remove("g-sidenav-pinned");
            state.isPinned = true;
        } else {
            sidenav_show.classList.add("g-sidenav-pinned");
            state.isPinned = false;
        }
    },
    navbarFixed(state) {
        if (state.isNavFixed === false) {
            state.isNavFixed = true;
        } else {
            state.isNavFixed = false;
        }
    },
    toggleEveryDisplay(state) {
        state.showNavbar = !state.showNavbar;
        state.showSidenav = !state.showSidenav;
        state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
        state.hideConfigButton = !state.hideConfigButton;
    },
    toggleSidenavCollapse(state) {
        state.isSidenavCollapsed = !state.isSidenavCollapsed;
    },
    setSidenavCollapsed(state, payload) {
        state.isSidenavCollapsed = payload;
    },
    color(state, payload) {
        state.color = payload;
    },
    SET_MENU_DATA(state, payload) {
        state.menuData = payload;
    },
    setMainMenu(state, payload) {
        state.mainmenuData = payload;
    },
    SET_DASHBOARD_DATA(state, payload) {
        state.dashboardData = payload;
    },
    setDashboardTableCards(state, payload) {
        state.dashboardTableCards = payload;
    },
    setVolunteerModules(state, payload) {
        state.volunteerModules = payload;
    },
    setPermissionData(state, payload) {
        state.permissionData = payload;
    },
    SET_SESSION_DATA(state, payload) {
        state.sessionData = payload;
        setLocalStorage("sessionData", payload)
    },
    SET_LOGOUT_RESPONSE(state, payload) {
        state.logoutResponse = payload;
    },
    CLEAR_SESSION_DATA(state) {
        state.sessionData = {};
        removeLocalStorage("sessionData");
    },
    SET_LAST_ACTIVE_SIDE_NAV_ROUTE(state, payload) {
        state.lastActiveSideNavRoute = payload;
        setLocalStorage("lastActiveSideNavRoute", payload);
    },
    SET_SIDEBAR_ROUTES(state, payload) {
        state.sidebarRoutes = payload;
    }
}

const actions = {
    setColor({ commit }, payload) {
        commit("color", payload);
    },

    // async fetchDashboardData2({ commit }) {
    //     try {
    //         const response = {
    //             cardsList: {
    //                 adminMenuCards: [
    //                     {
    //                         id: "pendingRegistration",
    //                         label: "Pending Registration(s)",
    //                         uri: "/pending-registrations/:locationID",
    //                     },
    //                     {
    //                         id: "numberOfUsers",
    //                         label: "Number of Users",
    //                         uri: "/users",
    //                     },
    //                     {
    //                         id: "schedulingUnits",
    //                         label: "Scheduling Units",
    //                         uri: "",
    //                     },
    //                     {
    //                         id: "messagingUnitSMS",
    //                         label: "Messaging Units (SMS)",
    //                         uri: "",
    //                     },
    //                     {
    //                         id: "messagingUnitEmail",
    //                         label: "Messaging Units (E-mail)",
    //                         uri: "",
    //                     },
    //                     {
    //                         id: "usage",
    //                         label: "Month-to-date Usage",
    //                         uri: "",
    //                     },
    //                     {
    //                         id: "admin_pending_swaps",
    //                         label: "Pending Swap Requests",
    //                         uri: "",
    //                     },
    //                     {
    //                         id: "messageTracker",
    //                         label: "Message Tracker",
    //                         uri: "",
    //                     }
    //                 ],
    //                 volunteerMenuCards: [
    //                     {
    //                         id: "upcomingAssignmentsCount",
    //                         label: "Upcoming Assignments Count",
    //                         uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                     },
    //                     {
    //                         id: "signUpAssignments",
    //                         label: "Sign-up Opportunities",
    //                         uri: `${baseUrl}/volunteer-signup/<personid>/<locationid>`,
    //                     },
    //                     {
    //                         id: "unconfirmedUpcomingAssignments",
    //                         label: "Upcoming Assignments",
    //                         uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                     },
    //                     {
    //                         id: "userPendingSwaps",
    //                         label: "Pending swap requests",
    //                         uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                     },
    //                     {
    //                         id: "userAvailability",
    //                         label: "Availability records",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/2/personid/<personid>`,
    //                     },
    //                     {
    //                         id: "userRules",
    //                         label: "Scheduling rules",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/6/personid/<personid>`,
    //                     },
    //                     {
    //                         id: "userPreferences",
    //                         label: "Preferred Activities and/or Workgroups",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/3/personid/<personid>`,
    //                     }
    //                 ],
    //                 adminToolsCards: [
    //                     {
    //                         id: "superadmin_viewlogs",
    //                         label: "View Logs",
    //                         uri: "/logs",
    //                         uri_type: "page",
    //                         iconname: "description",
    //                         iconcolor: "text-white",
    //                         iconbackground: "primary"
    //                     },
    //                     {
    //                         id: "superadmin_orgs",
    //                         label: "View Organizations",
    //                         uri: "/organization/view",
    //                         uri_type: "page",
    //                         iconname: "streetview",
    //                         iconcolor: "text-white",
    //                         iconbackground: "dark"
    //                     },
    //                     {
    //                         id: "superadmin_apilist",
    //                         label: "Api List",
    //                         uri: "/api-list/:locationID",
    //                         uri_type: "page",
    //                         iconname: "receipt_long",
    //                         iconcolor: "text-white",
    //                         iconbackground: "success"
    //                     },
    //                 ],
    //                 setupOrgCards: [
    //                     {
    //                         id: "setupWizard",
    //                         label: "Setup Wizard",
    //                         uri: `${baseUrl}/MF/cs-mf-setupwizard`,
    //                         uri_type: "modal",
    //                         iconname: "settings",
    //                         iconcolor: "text-white",
    //                         iconbackground: "primary"
    //                     },
    //                     {
    //                         id: "editOrganization",
    //                         label: "Edit Organization",
    //                         uri: "/organization/edit/:organizationID",
    //                         uri_type: "page",
    //                         iconname: "corporate_fare",
    //                         iconcolor: "text-white",
    //                         iconbackground: "dark"
    //                     },
    //                     {
    //                         id: "editLocation",
    //                         label: "Edit Location",
    //                         uri: "/location/edit/:locationID",
    //                         uri_type: "page",
    //                         iconname: "location_on",
    //                         iconcolor: "text-white",
    //                         iconbackground: "success"
    //                     },
    //                 ]
    //             },
    //             modules: {
    //                 adminMenuModules: [
    //                     {
    //                         id: "manageSchedule",
    //                         label: "Manage Schedule",
    //                         uri: `${baseUrl}/MF/cs-mf-manageschedules`,
    //                         uri_type: "page",
    //                         title: "Manage Schedule",
    //                         role: "admin",
    //                         sequence: 1,
    //                     },
    //                                             {
    //                         id: "billing",
    //                         label: "Billing",
    //                         uri: `${baseUrl}/MF/cs-mf-billing`,
    //                         uri_type: "page",
    //                         title: "Billing",
    //                         role: "admin",
    //                         sequence: 1,
    //                     },
    //                     {
    //                         id: "manageSkillsRoles",
    //                         label: "Manage Skills/Roles",
    //                         uri: `/skills/:locationID`,
    //                         uri_type: "page",
    //                         title: "create/edit/delete Skills/Roles test",
    //                         role: "admin",
    //                         sequence: 1,
    //                     },
    //                     {
    //                         id: "messagingCenter",
    //                         label: "Messaging Center",
    //                         uri: `/messaging-center/:locationID`,
    //                         uri_type: "page",
    //                         title: "send messages to volunteers/users",
    //                     },
    //                     {
    //                         id: "signupForm",
    //                         label: "Sign-up Form",
    //                         uri: `/volunteer-signup/:personID/:locationID`,
    //                         uri_type: "page",
    //                         title: "Sign-up Form",
    //                     },
    //                     {
    //                         id: "users",
    //                         label: "Users",
    //                         uri: "/users",
    //                         uri_type: "page",
    //                         title: "Manage Users",
    //                     },
    //                     {
    //                         id: "activitiesEvents",
    //                         label: "Activities/Events",
    //                         uri: "/activities-events",
    //                         uri_type: "page",
    //                         title: "Manage Activities/Events",
    //                     },
    //                     {
    //                         id: "allSchedules",
    //                         label: "All Schedules",
    //                         uri: `/all-schedules/:locationID`,
    //                         uri_type: "page",
    //                         title: "Manage All Schedules",
    //                     },
    //                     {
    //                         id: "manageOrganizations",
    //                         label: "Manage Organizations",
    //                         uri: "/organization/manage",
    //                         uri_type: "page",
    //                         title: "Manage Organizations",
    //                     },
    //                 ],
    //                 volunteerMenuModules: [
    //                     {
    //                         id: "myProfile",
    //                         label: "my Profile",
    //                         uri: `${baseUrl}/volunteer-signup/<personid>/<locationid>`,
    //                         title: "edit your profile details - name, mobile number, etc."
    //                     },
    //                     // {
    //                     //     id: "upcomingAssignmentsCount",
    //                     //     label: "Upcoming Assignments Count",
    //                     //     uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                     //     title: "view your upcoming assignments and schedule"
    //                     // },
    //                     {
    //                         id: "signUpAssignments",
    //                         label: "Sign-up Opportunities",
    //                         uri: `${baseUrl}/volunteer-signup/<personid>/<locationid>`,
    //                         title: "view open assignments that you can sign up for"
    //                     },
    //                     {
    //                         id: "unconfirmedUpcomingAssignments",
    //                         label: "Upcoming Assignments",
    //                         uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                         title: "view and respond to pending assignment requests"
    //                     },
    //                     {
    //                         id: "userPendingSwaps",
    //                         label: "Pending swap requests",
    //                         uri: `${baseUrl}/MF/cs-mf-personschedule/?personid=<personid>`,
    //                         title: "view and manage pending swap requests"
    //                     },
    //                     {
    //                         id: "userAvailability",
    //                         label: "Availability records",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/2/personid/<personid>`,
    //                         title: "set dates you are available or unavailable (vacation dates, etc.)"
    //                     },
    //                     {
    //                         id: "userRules",
    //                         label: "Scheduling rules",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/6/personid/<personid>`,
    //                         title: "set scheduling rules to determine how often or with whom you prefer to serve"
    //                     },
    //                     {
    //                         id: "userPreferences",
    //                         label: "Preferred Activities and/or Workgroups",
    //                         uri: `${baseUrl}/Manageuser/get/locationid/<locationid>/cmd/editperson/accordopt/3/personid/<personid>`,
    //                         title: "update the activities/services or workgroup that you prefer to serve"
    //                     },
    //                     {
    //                         id: "requestNewSkills",
    //                         label: "Serve in other Areas",
    //                         uri: `${baseUrl}/volunteer-signup/<personid>/<locationid>`,
    //                         uri_type: "modal",
    //                         title: "submit a request to be considered/added to other skills"
    //                     }
    //                 ]
    //             }
    //         }
    //         commit('SET_DASHBOARD_DATA', response.cardsList);
    //         commit('setDashboardTableCards', response.modules.adminMenuModules);
    //         commit('setVolunteerModules', response.modules.volunteerMenuModules);
    //     } catch (error) {
    //         console.error('Error fetching API data:', error);
    //     }
    // },
    // async fetchPermissionData({ commit }, payload) {
        // async fetchPermissionData({ commit }) {
    //     // const cmd = "userpermissions"
    //     try {
    //         // const locationid = payload.locationid;

    //         // var response = await fetchWithCache({ commit }, {
    //         //     apicmd: cmd,
    //         //     cacheKey: `apiCache_${cmd}_${locationid}`,
    //         //     postData: null,
    //         //     mutation: "setPermissionData",
    //         //     cacheDuration: 90000,
    //         //     url: `/auth/permissions?locationid=${locationid}`,
    //         //     method: "GET",
    //         // });

    //         // console.log("response", response);

    //         var response = {
    //             "cardslist": {
    //                 "adminMenuCards": [
    //                     "pendingRegistration",
    //                     "numberOfUsers",
    //                     "schedulingUnits",
    //                     "messagingUnitSMS",
    //                     "messagingUnitEmail",
    //                     "usage",
    //                     "admin_pending_swaps",
    //                     "messageTracker"
    //                 ],
    //                 "volunteerMenuCards": [
    //                     // "upcomingAssignmentsCount",
    //                     "signUpAssignments",
    //                     "unconfirmedUpcomingAssignments",
    //                     "userPendingSwaps",
    //                     "userAvailability",
    //                     "userRules",
    //                     "userPreferences"
    //                 ],
    //                 "adminToolsCards": [
    //                     "superadmin_viewlogs",
    //                     "superadmin_orgs",
    //                     "superadmin_apilist"
    //                 ],
    //                 "setupOrgCards": [
    //                     "setupWizard",
    //                     "editOrganization",
    //                     "editLocation"
    //                 ]
    //             }
    //         }

    //         commit('setPermissionData', response);

    //         return response;
    //     } catch (error) {
    //         console.error('Error fetching permission data:', error);
    //         throw error; // Re-throw to allow error handling upstream
    //     }
    // },
    async fetchDashboardData({ commit }, payload) {
        const locationid = payload?.locationid ?? payload?.locationId;
        const personid = payload?.personid ?? payload?.personId;
        try {
            const response = await api.get('/auth/menu-cards', {
                params: { locationid, personid }
            });
            const data = response.data || {};
            const cardsList = data.cardsList || {};
            const modules = data.modules || {};
            const adminMenuModules = modules.adminMenuModules || [];
            const volunteerMenuModules = modules.volunteerMenuModules || [];

            console.log("cardsList", cardsList);

            commit('SET_DASHBOARD_DATA', cardsList);
            commit('setDashboardTableCards', adminMenuModules);
            commit('setVolunteerModules', volunteerMenuModules);
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },
    async fetchPermissionData({ commit }, payload) {
        const locationid = payload?.locationid ?? payload?.locationId;

        try {
            const response = await api.get('/auth/permissions', {
                params: { locationid },
            });
            const data = response.data || {};
            console.log("data", data);
            commit('setPermissionData', data);
            return data;
        } catch (error) {
            console.error('Error fetching permission data:', error);
            throw error;
        }
    },
    async fetchSessionData({ commit, dispatch }) {
        try {
            const cmd = "getsessiondetails"

            try {
                return await fetchWithCache({ commit }, {
                    apicmd: cmd,
                    cacheKey: `apiCache_${cmd}`,
                    postData: { cmd: cmd },
                    mutation: "SET_SESSION_DATA",
                    cacheDuration: 60000,
                    url: `/managelocationajax`,
                });

            } catch (e) {
                console.log("Error in fetching session data", e);
            }
        }
        catch (e) {
            await dispatch('reporterror', e);
            this.reportError(e);
        }
    },
    async initializeSession({ commit, dispatch }) {
        const savedSession = getLocalStorage("sessionData");

        if (savedSession && Object.keys(savedSession).length > 0) {
            console.log("✅ Loading session from localStorage");
            commit("SET_SESSION_DATA", savedSession);
            return savedSession;
        }

        console.log("🌐 Fetching session from API...");
        const apiSession = await dispatch("fetchSessionData");
        return apiSession;
    },
    async submitLogout({ commit }) {
        const cmd = "logout";
        try {
            const response = await fetchWithCache({ commit }, {
                apicmd: cmd,
                cacheKey: `apiCache_${cmd}`,
                postData: { cmd: cmd },
                mutation: "SET_LOGOUT_RESPONSE",
                cacheDuration: 0,
                url: `/personajax`,
            });
            commit("CLEAR_SESSION_DATA");

            // Clear all cookies
            const clearAllCookies = () => {
                const cookies = document.cookie.split(";");
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i];
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
                    const domain = window.location.hostname;
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + domain;
                    if (domain.includes('.')) {
                        const parentDomain = '.' + domain.split('.').slice(-2).join('.');
                        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + parentDomain;
                    }
                }
            };

            clearAllCookies();

            return response;
        } catch (error) {
            console.error('Error in logout:', error);
        }
    },
    async fetchSidebarRoutes({ commit }) {
        const locationid = getLocationId();

        try {
            const response = await api.get(`/auth/sidebar?locationid=${locationid}`);
            console.log("response from fetchSidebarRoutes", response.data);
            commit("SET_SIDEBAR_ROUTES", response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching sidebar routes:', error);
        }
    }
}

const getters = {
    stHideConfigButton: state => state.hideConfigButton,
    stIsPinned: state => state.isPinned,
    stIsSidenavCollapsed: state => state.isSidenavCollapsed,
    stShowConfig: state => state.showConfig,
    stSidebarType: state => state.sidebarType,
    stIsRTL: state => state.isRTL,
    stColor: state => state.color,
    stIsNavFixed: state => state.isNavFixed,
    stIsAbsolute: state => state.isAbsolute,
    stShowNavs: state => state.showNavs,
    stShowSidenav: state => state.showSidenav,
    stShowNavbar: state => state.showNavbar,
    stShowFooter: state => state.showFooter,
    stShowMain: state => state.showMain,
    stIsDarkMode: state => state.isDarkMode,
    stNavbarFixed: state => state.navbarFixed,
    stAbsolute: state => state.absolute,
    stMenuData: state => state.menuData,
    stMainMenuData: state => state.mainmenuData,
    stDashboardData: state => state.dashboardData,
    stAdminMenuCards: state => state.dashboardData?.adminMenuCards || [],
    stAdminToolsCards: state => state.dashboardData?.adminToolsCards || [],
    stSetupOrgCards: state => state.dashboardData?.setupOrgCards || [],
    stDashboardTableCards: state => state.dashboardTableCards || [],
    stVolunteerModules: state => state.volunteerModules || [],
    stPermissionData: state => state.permissionData?.cardslist || null,
    stFullPermissionData: state => state.permissionData || {},
    stSessionData: state => state.sessionData,
    stLogoutResponse: state => state.logoutResponse,
    stLastActiveSideNavRoute: state => state.lastActiveSideNavRoute,
    stSidebarRoutes: state => state.sidebarRoutes,
    stExternalRoutes: state => state.sidebarRoutes?.external_routes || [],
}

export default {
    state,
    mutations,
    actions,
    getters
}